import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { reduce } from 'lodash'
import styles from './style.module.scss'

const mapStateToProps = ({ menu }) => ({
  isMenuTop: menu.isMenuTop,
  menuTopData: menu.menuTopData,
  menuLeftData: menu.menuLeftData,
})

@withRouter
@connect(mapStateToProps)
class Breadcrumbs extends React.Component {
  state = {
    breadcrumb: [],
  }

  componentDidMount() {
    this.setBreadcrumbs(this.props)
  }

  componentWillReceiveProps(newProps) {
    this.setBreadcrumbs(newProps)
  }

  setBreadcrumbs = props => {
    const { isMenuTop, menuTopData, menuLeftData } = this.props
    this.setState({
      breadcrumb: this.getBreadcrumb(props, isMenuTop ? menuTopData : menuLeftData),
    })
  }

  getPath(data, url, parents = []) {
    // console.log('url:')
    // console.log(url)
    // console.log('parents:')
    // console.log(parents)
    const items = reduce(
      data,
      (result, entry) => {
        // console.log('result:')
        // console.log(result)
        // console.log('entry')
        // console.log(entry)
        // 已找到了則略過
        if (result.length) {
          return result
        }
        // 找到網址符合
        if (entry.url === url) {
          return [entry].concat(parents)
        }
        // 找到網址prefix符合,例如/patients/ceb90b28a12d468fbb87e88781d43447符合/patients的網址
        const urlSplit = url.split('/')
        if (urlSplit.length > 1 && entry.url === `/${urlSplit[1]}`) {
          return [entry].concat(parents)
        }
        // 有父結點向子結點travel
        if (entry.children) {
          const nested = this.getPath(entry.children, url, [entry].concat(parents))
          return (result || []).concat(nested.filter(e => !!e))
        }
        return result
      },
      [],
    )
    return items.length > 0 ? items : [false]
  }

  getBreadcrumb = (props, items) => {
    // console.log('props:')
    // console.log(props)
    // console.log('items:')
    // console.log(items)
    const [activeMenuItem, ...path] = this.getPath(items, props.location.pathname)
    // activeMenuItem:當前menu item object
    // path從頭到mentu item的object
    // console.log('activeMenuItem:')
    // console.log(activeMenuItem)
    // console.log('path:')
    // console.log(path)
    // console.log(`path.length:${path.length}`)

    if (activeMenuItem && path.length) {
      return path.reverse().map((item, index) => {
        // console.log(`item index:${index}`)
        // console.log(item)

        // 2層子節點
        if (index === path.length - 1) {
          return (
            <span key={item.key}>
              {/*              <span className={`${styles.arrow} text-muted`} />
              <span className="text-muted">{item.title}</span> */}
              <span className={styles.arrow} />
              <strong>{activeMenuItem.title}</strong>
            </span>
          )
        }
        return (
          <span key={item.key}>
            <span className={`${styles.arrow} text-muted`} />
            <span className="text-muted">{item.title}</span>
          </span>
        )
      })
    }
    // 1層子節點
    return (
      <span>
        <span className={styles.arrow} />
        <strong>{activeMenuItem.title}</strong>
      </span>
    )
  }

  render() {
    const { breadcrumb } = this.state
    return (
      <div className={styles.breadcrumbs}>
        <div className={styles.path}>
          <Link to="/dashboard" className="text-muted">
            首頁
          </Link>
          {breadcrumb}
        </div>
      </div>
    )
  }
}

export default Breadcrumbs
